import { createContext, useContext, useState } from "react";
import BookingModal from "../components/BookingModal";
import QuoteModal from "../components/QuoteModal";

const BookingContext = createContext(null);

export const useConversion = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [presetPackage, setPresetPackage] = useState(null);
  const [presetService, setPresetService] = useState(null);

  const openBooking = (pkgId = null) => {
    setPresetPackage(pkgId);
    setBookingOpen(true);
  };
  const openQuote = (service = null) => {
    setPresetService(service);
    setQuoteOpen(true);
  };

  return (
    <BookingContext.Provider value={{ openBooking, openQuote }}>
      {children}
      <BookingModal open={bookingOpen} onOpenChange={setBookingOpen} presetPackage={presetPackage} />
      <QuoteModal open={quoteOpen} onOpenChange={setQuoteOpen} presetService={presetService} />
    </BookingContext.Provider>
  );
};
